module.exports = "<h1 mat-dialog-title>Confirm Action</h1>\r\n\r\n<mat-dialog-content>\r\n    <p>{{question}}</p>\r\n</mat-dialog-content>\r\n\r\n<mat-dialog-actions fxLayout=\"row\" fxLayoutAlign=\"end\" fxLayoutGap=\"10px\">\r\n    <button mat-button type=\"button\" color=\"primary\" mat-dialog-close>{{cancelButtonLabel}}</button>\r\n    <button mat-raised-button type=\"button\" color=\"primary\" (click)=\"actionConfirmed()\">{{confirmButtonLabel}}</button>\r\n</mat-dialog-actions>";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/confirm-dialog/confirm-dialog.component.html
// module id = 621
// module chunks = 1